import './BackLink.css';

export interface BackLinkProps {
  label: string;
  onClick: () => void;
}

// "‹ Today" etc — the one way out of a screen reached by drilling in
// (currently just the Materials workshop; Auditions/Project detail screens
// will reuse this once they exist, B2+).
export function BackLink({ label, onClick }: BackLinkProps) {
  return (
    <button type="button" class="back-link" onClick={onClick}>
      <span aria-hidden="true">‹</span> {label}
    </button>
  );
}
